// extracted by mini-css-extract-plugin
module.exports = {"container":"Rating_container__3WZAc","starRating":"Rating_starRating__1dJkE","starsContainer":"Rating_starsContainer__26dXt"};